import React, { forwardRef } from "react";
import { buttonTypeConstants, EMPTY_STRING } from "../../../constants";
import { LoadingIndicator } from "../../utility";

//-------Button component start here
const Button = forwardRef((props, ref) => {
  const {
    handleClick,
    type,
    label,
    buttonType,
    IconImage,
    className = "",
    isLoading = false,
    isDisabled = false,
    title = EMPTY_STRING,
    iconClassName = "",
    isDisplayNone = false,
  } = props;

  const IS_DISABLED =
    isDisabled || buttonType === buttonTypeConstants.LOADING_BUTTON;

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevents button from being triggered
    }
  };

  const getContent = () => {
    let content = null;
    const BUTTON_TYPE = isLoading
      ? buttonTypeConstants.LOADING_BUTTON
      : buttonType;

    switch (BUTTON_TYPE) {
      case buttonTypeConstants.LOADING_BUTTON:
        content = (
          <>
            <span>
              <LoadingIndicator />
            </span>
            Processing...
          </>
        );
        break;
      default:
        content = (
          <>
            {IconImage && (
              <IconImage className={`button-icon-image ${iconClassName}`} />
            )}
            {label}
          </>
        );
    }
    return content;
  };

  return (
    <button
      ref={ref} // <-- added so OverlayTrigger works
      onKeyDown={handleKeyDown}
      type={type}
      title={title}
      disabled={IS_DISABLED}
      className={`d-flex justify-content-center
        ${IS_DISABLED && "disable-button"}
        ${isDisplayNone && "d-none"}
        ${className} gap-1 main-purple-button
        ${IconImage && "button-with-icon"}
        ${
          buttonType === buttonTypeConstants.GHOST_BUTTON
            ? "ghost-cancel-button "
            : buttonType === buttonTypeConstants.LIGHT_PURPLE
            ? "light-purple-button"
            : buttonType === buttonTypeConstants.ACTION_BUTTON
            ? "action-buttons"
            : buttonType === buttonTypeConstants.BLUE_BUTTON
            ? "blue-button"
            : buttonType === buttonTypeConstants.GHOST_BUTTON_2
            ? "gray-button"
            : buttonType === buttonTypeConstants.RED_BUTTON
            ? "red-button"
            : buttonType === buttonTypeConstants.TRANSPARENT_BUTTON_PURPLE
            ? "transparent-button-purple"
            : buttonType === buttonTypeConstants.GREEN_BUTTON
            ? "green-button"
            : buttonType === buttonTypeConstants.TRANSPARENT_BUTTON_GHOST
            ? "transparent-button-ghost"
            : buttonType === buttonTypeConstants.BLACK_BUTTON
            ? "black-button"
            : buttonType === buttonTypeConstants.RED_BUTTON_FILL
            ? "red-button-fill"
            : ""
        }`}
      onClick={handleClick}
    >
      {getContent()}
    </button>
  );
});
//-------Button component end here

export default Button;
